import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function for combining class names with conditional logic
 * and intelligently merging Tailwind CSS classes to prevent conflicts.
 *
 * @param inputs - A list of class values (strings, arrays, objects, etc.)
 * @returns A single, merged class name string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
